import { formatDuration } from '../../../lib/dateUtils';
import { formatShortDate } from '../../../lib/format';
import type { CompetitionCreativeRow } from './data/api';

export function competitionCreativeSubline(creative: CompetitionCreativeRow): string {
  return [creative.creativeType, creative.format]
    .filter((part): part is string => part !== null && part !== '')
    .join(' · ');
}

export function formatLength(duration: number | null): string {
  return formatDuration(duration) ?? 'Static';
}

export function formatDateAdded(date: string | null): string {
  return date === null ? '—' : formatShortDate(date);
}

export function flagEmoji(countryCode: string): string {
  return [...countryCode.toUpperCase()]
    .map((char) => String.fromCodePoint(127397 + char.charCodeAt(0)))
    .join('');
}
